import { changeDpiDataUrl }  from "./changeDPI";

const LOGGER = false;

export const IMAGE_RESOLUTIONS = {
  "72":  0.92,
  "120": 0.93,
  "150": 0.94,
  "300": 0.95,
}

export function imageResolutionByDpi(dpi) {
  return IMAGE_RESOLUTIONS[dpi.toString()];
}

export function getBase64FileSize(src) {
  const base64Str = src.split('base64,')[1];
  const decoded = atob(base64Str);
  return getFileSize(decoded.length);
}

export function getFileSize(bytes, decimals) {
    if(bytes == 0) return '0 Bytes';
    const k = 1024,
        dm = decimals || 2,
        sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
        i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

export function isLandscape(size) {
  return (size.width > size.height);
}

export function imageSize(dimensions, maxWidth, maxHeight) {
  let height = 0;
  const landscape = isLandscape(dimensions);
  const width = (landscape) ? maxWidth : maxHeight;
  const scaleFactor = width / dimensions.width;
  height = dimensions.height * scaleFactor;

  if(LOGGER) {
    console.log("Dimesions: ", dimensions.width + ' --- ' + dimensions.height);
    console.log("Landscape: " + landscape);
    console.log("scaleFactor: ", scaleFactor);
    console.log("W: " + width);
    console.log("H: " + height);
  }
  return {width: width, height: height};
}

export const getImageDimensions = dataURL => new Promise(resolve => {
  const img = new Image()
  img.onload = () => {
    resolve({
      height: img.height,
      width: img.width
    })
  }
  img.src = dataURL
})

export async function resizeImage(dimensions, source, maxWidth, maxHeight, dpi) {
  const newSize = imageSize(dimensions, maxWidth, maxHeight),
    width = newSize.width,
    height = newSize.height,
    resolution = imageResolutionByDpi(dpi);

  return new Promise(resolve => {
    let canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    
    let img = document.createElement("img");
    img.src = source;

    let context = canvas.getContext("2d");

    img.onload = function () {
      context.drawImage(img, 0, 0, width, height);
      
      const dataUrl = canvas.toDataURL('image/jpeg', resolution);
      resolve(changeDpiDataUrl(dataUrl, dpi));
    }
  });
}

